<ng-container *ngIf="block">
  <input class="text-neutral-50" type="text" onfocus="(this.type='date')"
  min="2020-01-01" max="{{dateMax}}"
    [placeholder]="block['label_' + helpersService.langCodeApi]" [(ngModel)]="value" (ngModelChange)="changeVal($event)"
    [ngClass]="{'border-active': value, 'firstInput': firstInput, 'lastInput': lastInput, 'oneInput': firstInput && lastInput, 'otherInput': !firstInput && !lastInput}">
</ng-container>